export enum UnitType {
    /** Dimensionless number. */
    Dimensionless,
    /** Dimensionless integer. */
    DimensionlessInteger,
    Origin,
    Time,
}
